module.exports = __webpack_public_path__ + "static/media/p0_8.7f944dcf.png";